import { ComboBox, DefaultButton, Dropdown, FontIcon, FontWeights, IDropdownOption, mergeStyles, mergeStyleSets, MessageBar, Modal, Panel, PanelType, PrimaryButton, ProgressIndicator, Stack, Text, TextField, Toggle, useTheme } from '@fluentui/react';
import { IAttendeeRegistrationListItem } from '../../../../Models/Event/IAttendeeRegistrationListItem';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import * as React from 'react';
import { ICreateInvoiceFromRegistration } from '../../../../Models/Invoice/ICreateInvoiceFromRegistration';
import { IUserProfile } from '../../../../Models/Profile/IUserProfile';

interface IAttendeeRegistrationDetailProps {
    item?: ICreateInvoiceFromRegistration;
    isOpen: boolean;
    close: () => void;
    propertyChanged: (key: string, value: any) => void;
    createInvoice: () => void;
    profile: IUserProfile
}


export const CreateInvoiceFromRegistrationView: React.FunctionComponent<IAttendeeRegistrationDetailProps> = (props) => {

    const [isLoading, setIsLoading] = React.useState(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [itemEdit, setItemEdit] = React.useState<ICreateInvoiceFromRegistration>();
    const theme = useTheme();

    const iconClass = mergeStyles({
        fontSize: 50,
        height: 50,
        width: 50,
        margin: '0 25px',
        color: theme.palette.themePrimary
    });
 
    const propertyChanged = (event?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.propertyChanged(id, newValue);
        }
    }

    const semesterChanged = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
        props.propertyChanged("priceType", option!.key as number);
    }

    const sendByEmail = (event: React.MouseEvent<HTMLElement>, checked?: boolean) => {
        props.propertyChanged("sendByEmail", checked ? checked:false);
    }


    React.useEffect(() => {
        setItemEdit(props.item);
    }, [props.item])

    const contentStyles = mergeStyleSets({
        container: {
            display: 'flex',
            flexFlow: 'column nowrap',
          
        },
        header: [
            theme.fonts.xLargePlus,
            {
                flex: '1 1 auto',
                borderTop: `4px solid ${theme.palette.themePrimary}`,
                color: theme.palette.neutralPrimary,
                display: 'flex',
                alignItems: 'center',
                fontWeight: FontWeights.semibold,
                padding: '12px 24px 25px 24px',
            },
        ],
        body: {
            flex: '4 4 auto',
            padding: '0 24px 24px 24px',
            overflowY: 'hidden',
            selectors: {
                p: { margin: '14px 0' },
                'p:first-child': { marginTop: 0 },
                'p:last-child': { marginBottom: 0 },
            },
        },
    });


    return (
        <>
                <Modal
                isOpen={props.isOpen}
                onDismiss={props.close}
                isBlocking={true}
                    className={contentStyles.container}>
                    <Stack>
                    <div className={contentStyles.header}>
                         Vytvoření faktury z registrace
                    </div>
                    <Stack tokens={{ childrenGap: 15 }} className={contentStyles.body}>
                        <TextField id="value" key="value" onChange={propertyChanged} label="Fakturovaná částka" value={props.item?.value?.toString()} />
                        <Dropdown selectedKey={props.item?.semester} onChange={semesterChanged} styles={{ root: { minWidth: 185 } }} label="Cena za" options={[{ key: 0, text: "Akci" }, { key: 1, text: "První pololetí" }, { key: 2, text: "Druhé pololetí" }]} />
                        <TextField id="text" key="text" onChange={propertyChanged} label="Název akce / Text na řádku faktury" value={props.item?.text} />
                    </Stack>
                    <Stack tokens={{ childrenGap: 15 }} horizontal className={contentStyles.body} >
                        <Toggle label="Odeslat emailem" checked={props.item?.sendByEmail} defaultChecked onText="Odeslat" offText="neodesílat" onChange={sendByEmail} />
                        <TextField id="email" disabled={!props.item?.sendByEmail} label="Email" onChange={propertyChanged} value={props.item?.email} styles={{ root: { width: '100%' } }} />
                    </Stack>
                    <Stack horizontal tokens={{ padding: 20, childrenGap: 15 }} horizontalAlign="center">
                            <PrimaryButton onClick={props.createInvoice}>Uložit</PrimaryButton>
                            <DefaultButton onClick={props.close}>Zavřít</DefaultButton>
                        </Stack>
                        {statusMessage && statusMessage.message ? <MessageBar messageBarType={statusMessage.type}>{statusMessage.message}</MessageBar> : null}
                    </Stack>
                </Modal>  
        </>)
}